<template>
  <div class="bottom_wrapper">
    <div class="bottom_middle">
      <div class="chart">人员进出统计</div>
      <dv-charts class="middle_chart" :option="stateOption" v-if="stateOption.series.length != 0"/>
      <dv-loading v-else>加载中...</dv-loading>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomChart',
  props: {
    stateData: {
      required: true,
      type: Object
    },
    windowWidth:{
      required: true,
      type: Number
    }
  },
  data() {
    return {
      typeOption: {
        series: [
          {
            type: 'pie',
            data: [],
            radius: ['30%', '50%'],
            insideLabel: {
              show: false,
            },
            outsideLabel: {
              labelLineEndLength: 10,
              formatter: '{value}\n{name}',
              style: {
                fontSize: 10,
                fill: '#5cd6ea',
                //fontWeight:'bolder'
              }
            }
          }
        ],
        color: ['#eab812', '#20e6d0','#ef47ce','#5186e8','#5555f8']
      },
      stateOption:{
        grid:{
          top:20
        },
        title: {
          show: true
        },
        legend: {
          data: [
            {name:'员工',color:'rgba(122,43,239,1)'},
            {name:'访客',color:'rgba(239,236,43,1)'},
          ],
          show: true,
          textStyle: {
            fontFamily: 'Arial',
            fontSize: 10,
            fill: '#67abf4',
          }
        },
        xAxis: {
          name: '',
          data: [],
          axisLine:{
            style: {
              stroke: '#67abf4',
              lineWidth: 1,
              fontWeight: 'bolder',
              fontSize: 10,
            },
          },
          axisLabel:{
            style:{
              fill: '#67abf4',
              fontSize: 10,
              rotate: 10,
              fontWeight: 'bolder',
            }
          },
          axisTick:{
            show:false
          },
          splitLine:{
            show:false
          }
        },
        yAxis: {
          name: '',
          data: 'value',
          min: 0,
          minInterval: 1,
          axisLine:{
            style: {
              stroke: '#67abf4',
              lineWidth: 1,
              fontWeight: 'bolder',
            },
          },
          axisLabel:{
            style:{
              fill: '#67abf4',
              fontSize: 10,
              rotate: 0,
              fontWeight: 'bolder',
            }
          },
          axisTick:{
            show:false
          },
          splitLine:{
            show:false
          }
        },
        series: [

        ]
      }
    }
  },
  methods:{
    getDays(){
      const today = new Date(); // 获取当前日期和时间
      const dates = []; // 用于存储最近10天的日期

      for (let i = 0; i < 10; i++) {
        const date = new Date(today); // 复制当前日期
        date.setDate(today.getDate() - i); // 减去天数
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
        const day = String(date.getDate()).padStart(2, '0');
        dates.push(`${month}月${day}日`); // 添加到数组中
      }
      return dates;
    },
    refreshData() {
      this.stateOption.legend.textStyle.fontSize = parseInt(this.windowWidth * 0.008)
      this.stateOption.xAxis.axisLine.style.fontSize = parseInt(this.windowWidth * 0.007)
      this.stateOption.xAxis.axisLabel.style.fontSize = parseInt(this.windowWidth * 0.007)
      this.stateOption.yAxis.axisLine.style.fontSize = parseInt(this.windowWidth * 0.007)
      this.stateOption.yAxis.axisLabel.style.fontSize = parseInt(this.windowWidth * 0.007)
      this.stateOption.xAxis.data = this.getDays()
      this.stateOption.series = [
        {
          name: '员工',
          data: [60,60,59,60,58,59,60,57,60,60],
          type: 'bar',
          gradient: {
            color: ['rgba(122,43,239,1)', 'rgba(122,43,239, 0)']
          },
          label:{
            show:true,
            formatter: '{value} 人'
          }
        },
        {
          name: '访客',
          data: [12,6,9,10,7,9,10,12,6,8],
          type: 'bar',
          gradient: {
            color: ['rgba(239,236,43,1)', 'rgba(239,236,43, 0)']
          },
          label:{
            show:true,
            formatter: '{value} 人'
          }
        },
      ]
      this.stateOption = {...this.stateOption}

      this.typeOption.series[0].outsideLabel.style.fontSize = parseInt(this.windowWidth * 0.008)
      this.typeOption.series[0].data = this.typeDate
    }
  }
}
</script>

<style lang="less" scoped>
.bottom_wrapper{
  width:100%;
  height:100%;
  display: flex;
  position: relative;
  .flex_1{
    flex:1
  }
  .ml_20{
    margin-left:1.5vw
  }
  .mt_20{
    margin-top:2vh
  }
  .decoration-1{
    width:1vw;
  }
  .bottom_middle{
    width: 96%;
    height: 100%;
    box-sizing: border-box;
    .chart{
      height: 2vh;
      text-align: center;
      line-height: 3vh;
      font-size: 1.1vw;
      color:#67abf4;
      font-weight: bolder
    }
    .middle_chart{
      height:80%
    }
  }
}
</style>
